import Sidemenu from './sidemenu';
import RouteContainer from './routecontainer';
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { NotificationContainer } from 'react-notifications';
class Container extends React.Component {
    render() {
        return (
            <div className="row mobile_margin">
                <div className="col-lg-3 col-md-4 col-sm-12 side_menu" id="side_menu" style={{ backgroundColor: '#fff', overflowY: 'scroll' }}>
                    <Sidemenu />
                </div>
                <div className="col-lg-9 col-md-8 col-sm-12" style={{ minHeight: '90vh', maxHeight: '90vh', overflowY: 'scroll' }}>
                    <RouteContainer />
                    <NotificationContainer />
                </div>
            </div>
        )
    }

}
export default Container